import { useCallback } from 'react';
import { BiCtaNames, BiModalTypes, BiScreenTypes } from '../bi/types';
import { useDomOrderConfirmationModal } from '../components/wizard-footer/dom-order-confirmation-modal';
import { PanoramaTransactions } from '../panorama/constants';
import { usePanoramaFunctions } from '../panorama/use-panorama-functions';
import { useAnalyzeFullSiteQuery } from '../queries/use-analyze-full-site-query';
import { DOM_ORDER_FIX_OPTION } from '../rule-mappers/site-level-rules/dom-order/use-dom-order-rule';
import { useReorganizePagesDOMOrder } from '../rule-mappers/site-level-rules/dom-order/use-reorganize-pages-dom-order';
import { useBiLogger } from './use-bi-logger';
export const useAnalyzeFullSiteAxeClick = () => {
  const {
    startPanoramaTransaction,
    finishPanoramaTransaction
  } = usePanoramaFunctions();
  const {
    refetch: analyzeFullSite
  } = useAnalyzeFullSiteQuery();
  const {
    reorganizePagesDOMOrder
  } = useReorganizePagesDOMOrder();
  const {
    showConfirmationModal
  } = useDomOrderConfirmationModal();
  const biLogger = useBiLogger();
  const handleCancel = useCallback(() => {
    biLogger.modalCtaClick({
      ctaName: BiCtaNames.Cancel,
      modalType: BiModalTypes.UnableToOrganizeDOMOrder
    });
  }, [biLogger]);
  const handleTryAgain = useCallback(async fixOption => {
    biLogger.modalCtaClick({
      ctaName: BiCtaNames.TryAgain,
      modalType: BiModalTypes.UnableToOrganizeDOMOrder
    });
    if (fixOption) {
      await reorganizePagesDOMOrder({
        fixOption,
        handleCancel,
        handleTryAgain,
        isManuallyCompleted: false,
        screenType: BiScreenTypes.WelcomeScreen
      });
    }
  }, [biLogger, reorganizePagesDOMOrder, handleCancel]);
  const handleAnalyzeFullSiteAxeClick = useCallback(async (isChecked, showDomOrderCheckbox) => {
    startPanoramaTransaction(PanoramaTransactions.welcomeScreenAnalyzeSite, {
      isChecked
    });
    biLogger.ctaClick({
      ctaName: BiCtaNames.ScanButton
    });
    if (showDomOrderCheckbox) {
      if (isChecked) {
        await reorganizePagesDOMOrder({
          fixOption: {
            value: DOM_ORDER_FIX_OPTION.AUTO
          },
          handleCancel,
          handleTryAgain,
          isManuallyCompleted: false,
          screenType: BiScreenTypes.WelcomeScreen
        });
      } else {
        biLogger.modalView({
          modalType: BiModalTypes.ProceedWithoutAutoDOM
        });
        await showConfirmationModal();
      }
    } else {
      await analyzeFullSite();
    }

    // TODO: do we need to finish the transaction here? maybe on job completion?
    finishPanoramaTransaction(PanoramaTransactions.welcomeScreenAnalyzeSite, {
      isChecked
    });
  }, [startPanoramaTransaction, biLogger, finishPanoramaTransaction, reorganizePagesDOMOrder, handleCancel, handleTryAgain, analyzeFullSite, showConfirmationModal]);
  return {
    handleAnalyzeFullSiteAxeClick
  };
};
//# sourceMappingURL=use-analyze-full-site-axe-click.js.map